/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  OverflowTooltip,
  Space,
} from '@tonic-one/react';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiTokenRes, ApiData } from '../types';
import InputFrom from '../InputFrom';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';

export const EditModal = React.memo(
  (props: {
    visible: boolean;
    onSave: (value: ApiTokenRes) => void;
    onClose: () => void;
    orgId: string;
    title: string;
    editTokenData?: ApiData | null;
  }) => {
    const { orgId, editTokenData } = props;
    const { t } = useTranslation();
    const { widthEditablePermission } = usePermissionStore();
    const [isSaveDisable, setSaveDisable] = useState(true);
    const [value, setValue] = useState<ApiTokenRes>({
      category: 0,
      description: '',
      name: '',
      scope: {
        sweepingMails: false,
        mitigationMails: false,
        mitigationAccounts: false,
        siemSecurityEvents: false,
        remediationMails: false,
        intelligent: false,
      },
    });
    useEffect(() => {
      if (editTokenData) {
        const selectedEditTokenData = {
          category: editTokenData.category,
          description: editTokenData.description || '',
          name: editTokenData.name,
          scope: editTokenData.scope,
        };
        setValue(selectedEditTokenData);
      }
    }, [props.editTokenData]);
    useEffect(() => {
      if (
        JSON.stringify(value.name) === JSON.stringify(editTokenData?.name) &&
        JSON.stringify(value.description) ===
          JSON.stringify(editTokenData?.description) &&
        JSON.stringify(value.scope) === JSON.stringify(editTokenData?.scope)
      ) {
        setSaveDisable(true);
      }
    }, [value]);
    return (
      <Modal
        closeOnEsc
        closeOnOutsideClick={false}
        isClosable
        isOpen={props.visible}
        onClose={props.onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <OverflowTooltip>{props.title}</OverflowTooltip>
          </ModalHeader>
          <ModalBody>
            <InputFrom
              onChange={setValue}
              isSaveDisable={setSaveDisable}
              orgId={orgId}
              editTokenData={props.editTokenData}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              minWidth="20x"
              disabled={
                isSaveDisable ||
                !widthEditablePermission(PermissionNameEnum.administrator)
              }
              onClick={() => {
                props.onSave(value);
              }}
            >
              {t('administration.apiToken.button.update')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);
